<template>
  <div class="space-y-6">
    <div
      v-if="currentStep === CreateReviewStep.PresetSelection"
      class="flex-shrink-0 container"
    >
      <div class="grid grid-cols-1 flex-wrap">
        <CallToAction
          v-for="p in reviewPresetsMap"
          :key="p.id"
          :title="p.title"
          :subtitle="p.subtitle"
          :description="p.description"
          :is-automated="p.isAutomated"
          @handle="setPreset(p.id as ReviewPreset)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ReviewPreset } from '@core/domain/types/review-preset.type'
import { injectStrict } from '@app/utils/injectStrict'
import { CreateReviewKey, CreateReviewStep } from '../useCreateProjectReview'
import { nextTick } from 'vue'
import CallToAction from './components/CallToAction.vue'

const {
  preset,
  currentStep,
  goToNextStep,
  reviewPresets: reviewPresetsMap,
} = injectStrict(CreateReviewKey)

function setPreset(newPreset: ReviewPreset) {
  preset.value.preset = newPreset
  nextTick(() => goToNextStep())
}
</script>
